<template>
  <div>
    <al-modal
      :visible="isVisible"
      :heading="$t(heading)"
      :close-label="closeLabel"
      action-required
      name="session-expired-modal"
      @dismiss="exitProfile">
      <div v-if="!verifying" class="row">
        <div class="col-full">
          <p>{{ $t('sessionExpiredModal.content') }}</p>
          <al-button
            :loading="loading"
            :label="$t('button.sendCode')"
            name="modal-send-code-button"
            @click="sendCode" />
        </div>
      </div>

      <verify-account
        v-else
        is-modal
        @verifySuccess="onVerificationEnd"
        @verifyError="onVerificationEnd" />
    </al-modal>
  </div>
</template>

<script>
import { AlButton, AlModal } from '@mc-alberta/alcapone'
import { mapActions, mapMutations, mapState } from 'vuex'
import { ROUTES } from '@/constants'
import VerifyAccount from '@/pages/verify/Account'
import * as types from '@/store/mutation-types'

export default {
  name: 'SessionModal',
  components: { AlButton, AlModal, VerifyAccount },
  data: () => ({
    verifying: false
  }),
  computed: {
    ...mapState({
      isVisible(state) {
        // when the visibility changes we turn al-toggle loading to off
        this.setActionIsPending(false)
        return state.showSessionExpireNotice
      },
      serviceLayerError: (state) => state.serviceLayerError,
      loading: (state) => state.actionIsPending
    }),
    heading() {
      return this.verifying ? 'verification.headings.default' : 'sessionExpiredModal.heading'
    },
    closeLabel() {
      return this.verifying ? this.$t('button.cancel') : this.$t('button.exit')
    }
  },
  methods: {
    ...mapActions(['fetchVerificationId', 'logout']),
    ...mapMutations({
      setInterceptUnauthorized: types.SET_INTERCEPT_UNAUTHORIZED_ERROR,
      setActionIsPending: types.SET_ACTION_IS_PENDING,
      setSessionExpiredModal: types.SET_SESSION_EXPIRED_NOTICE
    }),
    async sendCode() {
      this.setActionIsPending(true)
      await this.fetchVerificationId()
      if (this.serviceLayerError) {
        this.$emit('error')
        this.setSessionExpiredModal(false)
      } else {
        this.verifying = true
        this.setInterceptUnauthorized(false)
      }
      this.setActionIsPending(false)
    },
    exitProfile() {
      this.$router.replace({ name: ROUTES.ENTRY, params: { skipConfirmation: true, logout: true } })
      this.resetModal()
    },
    onVerificationEnd() {
      this.setInterceptUnauthorized(true)
      this.resetModal()
    },
    resetModal() {
      this.setSessionExpiredModal(false)
      this.verifying = false
    }
  }
}
</script>
